import SystemSetting from './SystemSetting'

export default SystemSetting



// WEBPACK FOOTER //
// ./src/common/components/system-setting/index.jsx